module.exports = __webpack_public_path__ + "static/media/toolbar-main-tools.5bf65e31.svg";